import axios from 'axios'
import {getServerApi} from './config/deployment'
import { getAnyFirebaseToken } from './platform/auth/services/authService'
let envUri = getServerApi()
let placesAutocompleteUri = envUri+'/api/location/google/placeautocomplete'
let placesDetailsUri = envUri+'/api/location/google/placedetails'


export const getPlacePredictions = (searchTerm, types) => {
  return axios.get(placesAutocompleteUri,{
    params: {
      input: searchTerm,
      types: types,
      components:'country:ee'
    }
  })
    .then(resp => {
      return resp.data.predictions
    })
    .catch(err => {
      return []
    })
}

export const getPlaceDetails = (placeId) =>{
  return getAnyFirebaseToken()
    .then(token => {
      return axios.get(placesDetailsUri,{
        params: {
          placeid: placeId,
          fields: 'address_component,adr_address,formatted_address,geometry',
          region: 'eu',
          token: token
        }
      })
    })
    .then(resp => {
      if(Array.isArray(resp.data.result)) return resp.data.result[0]
      else return resp.data.result
    })
    .catch(err => {
      return {}
    })
}


// WEBPACK FOOTER //
// ./src/mapsRepository.js